// extracted by mini-css-extract-plugin
module.exports = {"labels":"labels__PUIsb","users":"users__28D88","statusCell":"statusCell__2d5g4","logSummary":"logSummary__2tkfk"};